
export default {
  data(){
    return {
      mounted: false
    }
  },
  mounted(){
    this.mounted = true
  },
  unmounted() {
    this.mounted = false
  }
}